

import "../../../TextButton/TextButton.st.css.js";
import "../../../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_224_0_AccordionItemCaret";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_224_0_AccordionItemCaret__root","textButton":"wds_1_224_0_AccordionItemCaret__textButton"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-accordion-caret-fill":"--wds-accordion-caret-fill","wds-accordion-caret-fill-hover":"--wds-accordion-caret-fill-hover"}; 




